module.exports = __webpack_public_path__ + "img/007bca1.webp";